import { COOKIE_LOAN_SEARCH } from '@/constants/cookies';
import { getLoan, getLoanSearch } from '@/graphql/queries/banking/loan';
import lang from '@/lang/middleware/products/banking/loans';
import { calculateLoan } from '@/scripts/loan';

export default async ({ $apolloQuery, app, $cookies, redirect, route, store }) => {
  const code = $cookies.get(COOKIE_LOAN_SEARCH);
  const defaultSearch = () => {
    $cookies.remove(COOKIE_LOAN_SEARCH);
    store.commit('search/reset', { type: 'loan' });
  };
  if (code && typeof code === 'string') {
    $apolloQuery(getLoanSearch, { code }).then(search => store.commit('search/set', search)).catch(defaultSearch);
  } else {
    defaultSearch();
  }

  await $apolloQuery(getLoan, { code: route.params.code }).then(loan => {
    if ((route.params.slug !== loan.slug) || (route.params.provider !== loan.institution.slug)) {
      return redirect(301, app.localePath(`/compare-loans/${loan.institution.slug}/${loan.code}/${loan.slug}/`));
    }
    const search = store.getters['search/get'];
    loan = calculateLoan(loan, search);
    store.$i18n.mergeLocaleMessage('en', lang.en);
    const listData = {
      monthly: store.$i18n.n(loan.monthlyRepayment, 'currency'),
      principal: store.$i18n.n(search.amount, 'currencyRound'),
      term: loan.termInMonths
    };
    const list = ['principal', 'term', 'monthly'].map(attr => store.$i18n.t(`show.list.${attr}`, listData));
    const title = [loan.institution.name, loan.name].join(' ');
    store.commit('products/set', loan);
    store.commit('jumbotron/SET_JUMBOTRON', { list, title, type: 'generic' });
    store.commit('pageContent/SET_DYNAMIC_BREADCRUMBS', [
      ['i18n/home', '/'],
      ['i18n/banking', '/money/'],
      ['i18n/loans', '/compare-loans/'],
      ['i18n/providers', '/compare-loans/lenders/'],
      [loan.institution.name, `/compare-loans/${loan.institution.slug}/`, 'mobile'],
      loan.name
    ]);
    store.commit('pageContent/setHead', { title });
  }).catch(_ => {
    redirect(302, app.localePath('/compare-loans/'), { flashClass: 'error', flashMessage: store.$i18n.t('errors.loanNotFound') });
  });
};
